import apiURL from "./apiURL";
import { createRequest, settingsRequest } from "@/common/helpers/RequestHelpers";
import { NotificationManager } from "react-notifications";

const agreementRequest = createRequest({
	urlPath: "/settings/agreement/",
	// local: true,
});

const Types = {
	PENSION_TAB: "PENSION_TAB",
    PENSION_SHOW_REASSESSMENT_MODAL: "PENSION_SHOW_REASSESSMENT_MODAL",
    PENSION_GET_REASSESSMENT: "PENSION_GET_REASSESSMENT",
    PENSION_UPDATE_REASSESSMENT_EMPLOYEE: "PENSION_UPDATE_REASSESSMENT_EMPLOYEE",
    PENSION_SET_REASSESSMENT_DATE: "PENSION_SET_REASSESSMENT_DATE",
    PENSION_SET_LETTER: "PENSION_SET_LETTER",
    PENSION_SET_AUDIT_LOGS: "PENSION_SET_AUDIT_LOGS",
	PENSION_SAVE_EMPLOYEES: "PENSION_SAVE_EMPLOYEES",
};

const pensionRequest = createRequest({
  urlPath: `/settings/pension`,
  // local: true,
});

const pensionTab = (tab) => ({
	type: Types.PENSION_TAB,
	tab,
});

const getEmployeePensions = () => {
	return async (dispatch, getState) => {
		await agreementRequest({
			method: "GET",
			path: "list/pensions",
		}).then(({ data }) => {
			dispatch(saveEmployeePensions(data));
		});
	};
};

const saveEmployeePensions = (data) => ({
	type: Types.PENSION_SAVE_EMPLOYEES,
	data,
});

const saveLetter = ({key, letter, id}) => {
  return (dispatch, getState) => {
    pensionRequest({
      method: "POST",
			body: {key, letter, id},
			path: "/letters",
		})
      .then(data => {
        console.log("Saved letter: ", data);
        dispatch(setLetter(letter));
        NotificationManager.success("Letter saved", "Success");
        dispatch(getLetter(key));
      })
      .catch((error) => {
        console.error("Error saving letter: ", error);
        NotificationManager.error("Error saving letter", "Error");
      });
    }
}

const getLetter = (key) => {
  return (dispatch, getState) => {
    pensionRequest({
      method: "GET",
			path: `/letters/${key}`,
		})
      .then(data => {
        console.log("Received letter: ", data?.data?.letter);
        dispatch(setLetter(data?.data?.letter))
      })
      .catch((error) =>{
        console.error("Error getting letter: ", error)
        NotificationManager.error("Error getting letter", "Error");}
    )
  }
}

const setLetter = (letter) => ({
  type: Types.PENSION_SET_LETTER,
  letter,
});

const getAuditLogs = (id) => {
  return (dispatch, getState) => {
    settingsRequest({
      method: "GET",
      path: `/auditLogs/item/${id}`,
    })
      .then((data) => {
        console.log("Received pension audit logs: ", data?.data);
        dispatch(setAuditLogs(data?.data));
      })
      .catch((error) => {
        console.error("Error getting pension audit logs: ", error);
        NotificationManager.error("Error getting pension audit logs", "Error");
      });
  }
}

const setAuditLogs = (auditLogs) => ({
  type: Types.PENSION_SET_AUDIT_LOGS,
  auditLogs,
});

const showReassessmentModal = (toggleModal) => ({
  type: Types.PENSION_SHOW_REASSESSMENT_MODAL,
  toggleModal,
});

const getReassessmentEmployees = () => {
  console.debug("getReassessmentEmployees");
  return (dispatch, getState) => {
    pensionRequest({
      path: `/reassessment`,
			method: "GET",
    })
      .then((data) => {
        console.debug("reassessment data: ", data.data);
        dispatch(showReassessmentEmployees(data.data));
      })
      .catch((err) => {
        console.error(err);
      });
  };
};

const saveReassessmentEmployees = (data) => {
  return async (dispatch, getState) => {
    pensionRequest({
      path: `/reassessment`,
			method: "POST",
      body: { data },
    })
      .then((data) => {
        console.log(data);
        NotificationManager.success("Successfully saved reassessment employees");
        dispatch(showReassessmentEmployees({ agreements: data.data }));
        dispatch(showReassessmentModal(false));
      }).catch((err) => {
        console.error(err);
        NotificationManager.error("Failed to save reassessment employees");
      });
    };
};

const showReassessmentEmployees = (data) => ({
  type: Types.PENSION_GET_REASSESSMENT,
  payload: data,
});

const updateReassessmentEmployee = (agreementId, groupId) => ({
  type: Types.PENSION_UPDATE_REASSESSMENT_EMPLOYEE,
  agreementId,
  groupId,
});

const setReassessmentDate = (date) => ({
  type: Types.PENSION_SET_REASSESSMENT_DATE,
  date,
});

const Actions = {
	pensionTab,
    showReassessmentModal,
    getReassessmentEmployees,
    saveReassessmentEmployees,
    updateReassessmentEmployee,
    saveLetter,
    getLetter,
    getAuditLogs,
	getEmployeePensions,
};

export { Types, Actions };
